// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createAdminShopify = (client) => ({
    /**
     * `POST /admin/shopify/import`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifyImportCreate
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/import/route.ts
     */
    import: (body, query, headers) => client.fetch("/admin/shopify/import", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/shopify/imports`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifyImportsRetrieve
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/imports/route.ts
     */
    listImports: (query, headers) => client.fetch("/admin/shopify/imports", { method: "GET", query, headers }),
    /**
     * `GET /admin/shopify/sync-status`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifySyncStatusRetrieve
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/sync-status/route.ts
     */
    listSyncStatus: (query, headers) => client.fetch("/admin/shopify/sync-status", { method: "GET", query, headers }),
    /**
     * `GET /admin/shopify/config`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifyConfigRetrieve
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/config/route.ts
     */
    retrieveConfig: (query, headers) => client.fetch("/admin/shopify/config", { method: "GET", query, headers }),
    /**
     * `POST /admin/shopify/config`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifyConfigCreate
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/config/route.ts
     */
    updateConfig: (body, query, headers) => client.fetch("/admin/shopify/config", { method: "POST", body, query, headers }),
    /**
     * `POST /admin/shopify/fetch`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminShopifyFetchCreate
     * @source packages/medusa-plugin-shopify-v2/src/api/admin/shopify/fetch/route.ts
     */
    updateFetch: (body, query, headers) => client.fetch("/admin/shopify/fetch", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=shopify.js.map